import * as React from 'react';
import Button from '../../../components/Button';
import styled from '../../../styled-components';

const Wrapper = styled.div`
    margin-top: 1.4em;
`;

const ButtonWrapper = styled.div`
    margin-top: 1.2rem;
    float: right;
    ${Button} + ${Button} {
        margin-left: 1rem;
    }
`;

const Modal = styled.div`
    display: block;
    position: fixed;
    z-index: 1;
    padding-top: 20rem;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgb(0, 0, 0);
    background-color: rgba(0, 0, 0, 0.4);
`;

const ModalContent = styled.div`
    background-color: #fefefe;
    margin: auto;
    padding: 2rem;
    border: 1px solid #888;
    max-width: 40rem;
    height: 14rem;
`;

interface DeleteVacancyButtonState {
    showConfirmDelete: boolean;
}

interface DeleteVacancyButtonProps {
    name: string;
    onOk: () => void;
}

class DeleteVacancyButton extends React.Component<DeleteVacancyButtonProps, DeleteVacancyButtonState> {
    constructor(props: DeleteVacancyButtonProps) {
        super(props);
        this.state = { showConfirmDelete: false };
        this.toggleShowConfirmDelete = this.toggleShowConfirmDelete.bind(this);
    }

    private toggleShowConfirmDelete() {
        this.setState({ showConfirmDelete: !this.state.showConfirmDelete });
    }

    public render() {
        return (
            <Wrapper>
                <Button normal onClick={this.toggleShowConfirmDelete}>Delete</Button>
                {this.state.showConfirmDelete && (
                    <Modal>
                        <ModalContent>
                            <h2>Delete</h2>
                            <div>
                                <p>Do you really want to delete V-Sponse "{this.props.name}"?</p>
                                <p>
                                    Note: V-Sponses will be deleted automatically after six months of inactivity.
                                </p>
                            </div>
                            <ButtonWrapper>
                                <Button normal onClick={this.toggleShowConfirmDelete}>
                                    No
                                </Button>
                                <Button
                                    onClick={() => {
                                        this.toggleShowConfirmDelete();
                                        this.props.onOk();
                                    }}
                                >
                                    Yes, delete
                                </Button>
                            </ButtonWrapper>
                        </ModalContent>
                    </Modal>
                )}
            </Wrapper>
        );
    }
}

export default DeleteVacancyButton;



// WEBPACK FOOTER //
// ./src/scenes/administrator/components/DeleteVacancyButton.tsx